<template>
  <div>
    <span v-if="!dataAlready">กำลังดึงข้อมูล...</span>
    <span v-if="dataAlready && !carInfo">ไม่พบรายการ</span>
  </div>
</template>
<script>
export default {
  name: 'DropAndGo_Document',
  data: () => ({
    dataAlready: false,
    id: '',
    file: '',
    form: {
      name: '',
      licenseNo: '',
      frameNo: '',
      tel: '',
      branchCode: '',
      detail: '',
      appointmentDate: '',
      appointmentTime: '',
      user: '',
      file: '',
      file2: ''
    },
    carInfo: ''
  }),
  async mounted () {
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    this.id = params.get('id')
    this.file = params.get('file')
    this.carInfo = await this.getCarInfo()
    if (this.file === 'file1' && this.carInfo.zr12file !== '') {
      window.location = this.carInfo.zr12file
    }
    if (this.file === 'file2' && this.carInfo.zr12file2 !== '') {
      window.location = this.carInfo.zr12file2
    }
  },
  methods: {
    async getCarInfo () {
      let _this = this
      _this.dataAlready = false
      return this.$axios
        .get(`${this.$apiUrl}dropandgoGet?id=${_this.id}`)
        .then(response => {
          _this.dataAlready = true
          return response.data
        })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/DropAndgo/document.vue